
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-nexplanon",
      function () {
        return require("private-next-pages/what-is-nexplanon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-nexplanon"])
      });
    }
  